module.exports = __webpack_public_path__ + "media/images/google_play-47810e0e9bc0dc38738ce8dd43135acf.png";